import { Label as RadixLabel } from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';

import {
  type WithChildren,
  type AriaLabelingProps,
  type DOMProps,
} from '@dynatrace/strato-components/core';

import * as styles from './Menu.sty.js';

/**
 * @public
 */
export interface MenuLabelProps
  extends WithChildren,
    AriaLabelingProps,
    DOMProps {}

/**
 * Used to render a label. It won't be focusable using arrow keys.
 * @public
 */
export const Label = /* @__PURE__ */ forwardRef<HTMLDivElement, MenuLabelProps>(
  (
    {
      children,
      id,
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy,
      'aria-describedby': ariaDescribedBy,
      'aria-details': ariaDetails,
    },
    forwardedRef,
  ) => (
    <RadixLabel
      ref={forwardedRef}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
      aria-describedby={ariaDescribedBy}
      aria-details={ariaDetails}
      id={id}
      className={styles.label}
    >
      {children}
    </RadixLabel>
  ),
);

(Label as typeof Label & { displayName: string }).displayName = 'Menu.Label';
